module.exports = __webpack_public_path__ + "images/emoji/clipboard.d7df4562fd315b13d7c1.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/clipboard.png
// module id = i2v0
// module chunks = 24